import React, { FC, memo, useEffect } from 'react';
import { FormControl } from 'react-bootstrap';
import { staticImagesRelativePath } from '../../../utils/staticImagesRelativePath';
import cls from './TariffSetConnectionLimits.module.scss';
import { TariffIntegrationLimitType } from '../tariff.types';
import { checkAndReturnIconForIntegration } from '../../../utils/checkAndReturnIconForIntegration';

type TariffSetConnectionLimitsProps = {
  integrations: TariffIntegrationLimitType[];
  setIntegrationsLimits: React.Dispatch<React.SetStateAction<TariffIntegrationLimitType[]>>;
  generalIntegrationsLimit?: number;
  onGeneralLimitChange?: (value: number) => void; // Adding callback for changing the general limit
  isEditingGeneralLimit?: boolean; // Flag for allowing editing
};

const TariffSetConnectionLimits: FC<TariffSetConnectionLimitsProps> = memo((props) => {
  const {
    integrations,
    setIntegrationsLimits,
    generalIntegrationsLimit,
    onGeneralLimitChange,
    isEditingGeneralLimit = false, // Editing disabled by default
  } = props;
  const [allConnection, setAllConnection] = React.useState(generalIntegrationsLimit ?? -1);

  useEffect(() => {
    if (generalIntegrationsLimit !== undefined) {
      setAllConnection(generalIntegrationsLimit);
    }
  }, [generalIntegrationsLimit]);

  const handleGeneralLimitChange = (value: number) => {
    setAllConnection(value);
    if (onGeneralLimitChange) {
      onGeneralLimitChange(value);
    }
  };

  return (
    <div className={cls.Container}>
      <div className={cls.Header}>
        <h4 className="title-4">Connections</h4>
        <p className={cls.Subtitle}>Enter -2 for unlimited</p>
      </div>
      <div className={cls.Connection}>
        <label htmlFor="allConnection">General Limit</label>
        <FormControl
          type="text"
          id="allConnection"
          value={allConnection.toString()}
          readOnly={!isEditingGeneralLimit} // Allow editing only if isEditingGeneralLimit=true
          onChange={(e) => {
            if (
              typeof Math.abs(Number(e.target.value)) === 'number' &&
              !isNaN(Math.abs(Number(e.target.value)))
            ) {
              handleGeneralLimitChange(Number(e.target.value));
            }
          }}
          className={cls.ConnectionInput}
        />
      </div>
      <div className={cls.Connections}>
        {integrations.map((integration) => (
          <div key={integration.id} className={cls.Connection}>
            <label htmlFor={integration.id} className={cls.AboutIntegration}>
              <img
                src={staticImagesRelativePath.integrationIcons[
                  checkAndReturnIconForIntegration(integration.id)
                ]()}
                alt={integration.name}
              />
              <span className="regular-text">{integration.name}</span>
            </label>
            <FormControl
              type="text"
              value={integration.limit}
              id={integration.id}
              onChange={(e) => {
                if (
                  typeof Math.abs(Number(e.target.value)) === 'number' &&
                  !isNaN(Math.abs(Number(e.target.value)))
                ) {
                  setIntegrationsLimits(
                    integrations.map((i) => {
                      if (i.id === integration.id) {
                        return { ...i, limit: Number(e.target.value) };
                      }
                      return i;
                    }),
                  );
                }
              }}
              className={cls.ConnectionInput}
            />
          </div>
        ))}
      </div>
    </div>
  );
});

export default TariffSetConnectionLimits;
